import React, { useState, useEffect } from "react";
import s from "./CreateRaffle.module.css";
//Servicio
import raffleService from "../../../../api/raffles/RafflesService";
import gamesService from "../../../../api/games/GamesService";
//Assets
import { useDispatch, useSelector } from "react-redux";
import { today } from "../../../../helpers/today";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "dayjs/locale/pt-br";
import "dayjs/locale/es";
//Material
import Button from "@mui/material/Button"
import FormControl from "@mui/material/FormControl"
import Grid from "@mui/material/Grid"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import TextField from "@mui/material/TextField"
import Switch from "@mui/material/Switch"
import InputAdornment from "@mui/material/InputAdornment"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import CircularProgress from "@mui/material/CircularProgress"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useTranslationException from "../../../../helpers/exceptions";
import { getNoaId } from "../../../../utils/session.utils";

// ============================== | CREATE RAFFLE | ============================

const CreateRaffle = ({
  setOpen,
  setRaffleSelected,
  editRaffle,
  setEditRaffle,
  modal,
  setCreate,
  callAllRaffles,
  setDetail,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);

  const organizationId = getNoaId()
  const gameOffersRedux = useSelector((state) => state.gamma.gameOffers);
  const organization = useSelector((state) => state.gamma.noaOrganization);
  const { language } = useSelector((state) => state.local);
  const raffleLotteries = useSelector((state) => state.gamma.raffleLotteries);
  const { allGameOffersActive } = useSelector((state) => state.gamma);
  const { activeOrganization } = useSelector((state) => state.gamma);

  const [gameOffersActive, setGameOffersActive] = useState([]);
  const [openError, setOpenError] = useState(false);
  const [gameOffers, setGameOffers] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [locale, setLocale] = useState(language);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    serie: false,
    price: false,
    percentage: false,
    number: false,
  });

  const percentajeTest =
    /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{1,2})?|\.[0-9]{1,2})$/;
  let todayforsend = new Date();

  const dateTransformer = (date) => {
    if (date) {
      const date2 = new Date(date);
      // Para fechas sin hora específica, usar medianoche UTC (00:00:00)
      // Esto evita problemas de zona horaria que convierten 00:00:00 local a 03:00:00 UTC
      const year = date2.getFullYear();
      const month = String(date2.getMonth() + 1).padStart(2, '0');
      const day = String(date2.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}T00:00:00`;
    }
    return null
  };

  const [form, setForm] = useState({
    createDate: dateTransformer(editRaffle?.createDate) || dateTransformer(today()),
    updateDate: dateTransformer(editRaffle?.updateDate) || null,
    couponsAmountPerBundle: editRaffle?.couponsAmountPerBundle || "",
    couponsBonusesAmount: editRaffle?.couponsBonusesAmount || "",
    eventDate: dateTransformer(todayforsend),
    expirationDate: editRaffle?.expirationDate || null,
    game: editRaffle?.game || "none",
    id: editRaffle?.id || null,
    incentive: editRaffle?.incentive || null,
    lottery: raffleLotteries[0],
    nroRaffle: editRaffle?.nroLottery || "",
    number: editRaffle?.number || "",
    offlineDeadline: editRaffle?.offlineDeadline || null,
    onlineDeadline: editRaffle?.onlineDeadline || editRaffle?.offlineDeadline || null,
    openDate: editRaffle?.openDate || null,
    organizationId: organizationId,
    percentage: editRaffle?.percentage || "",
    price: editRaffle?.price || "",
    provider: editRaffle?.number || "none",
    raffleDate: editRaffle?.raffleDate || null,
    retentionStimulus: editRaffle?.retentionStimulus || null,
    retentionWithHolding: editRaffle?.retentionWithHolding || null,
    serie: editRaffle?.serie || "",
    settlementDate: editRaffle?.settlementDate || null,
    status: editRaffle?.status || "RELEASED",
    taxable: editRaffle?.taxable || null,
    withHoldingAmount: editRaffle?.withHoldingAmount || null
  });

  const handleCreate = () => {
    const isInstant = form?.game?.modality?.game?.instant;
    
    console.log("🔍 Tipo de sorteo:", isInstant ? "INSTANTÁNEO" : "PREIMPRESO");
    console.log("🔍 expirationDate en form ANTES:", form.expirationDate);
    
    const obj = {
      ...form,
      game: form.game.modality.game,
      status: form?.status ? "RELEASED" : "EXCEPTED",
      percentage: form?.percentage * 1,
      organization: organization,
    };
    
    // Para sorteos preimpresos: setear couponsAmountPerBundle = 1 y eliminar campos de instantáneos
    if (!isInstant) {
      obj.couponsAmountPerBundle = 1;
      obj.couponsBonusesAmount = null;
      // Para preimpresos, expirationDate se mantiene tal cual viene del formulario (NO se modifica)
      // El usuario ya lo seleccionó y está validado como obligatorio
      // Asegurar que onlineDeadline tenga el mismo valor que offlineDeadline (fecha límite de venta)
      if (!obj.onlineDeadline && obj.offlineDeadline) {
        obj.onlineDeadline = obj.offlineDeadline;
      }
    } else {
      // Para sorteos instantáneos: calcular expirationDate automáticamente (un año desde hoy) solo si es null
      if (!obj.expirationDate) {
        const today = new Date();
        const oneYearLater = new Date(today);
        oneYearLater.setFullYear(today.getFullYear() + 1);
        obj.expirationDate = dateTransformer(oneYearLater);
      }
      
      // Para instantáneos, onlineDeadline debe tener el mismo valor que expirationDate
      // (ya que no hay campo offlineDeadline en el formulario para instantáneos)
      if (!obj.onlineDeadline) {
        obj.onlineDeadline = obj.expirationDate;
      }
      
      // Para instantáneos, couponsAmountPerBundle debe ser el valor que ingresó el usuario
      // Si el usuario ingresó un valor válido (> 0), se envía tal cual
      // Si está vacío, null, undefined o 0, se setea a null
      if (obj.couponsAmountPerBundle === "" || obj.couponsAmountPerBundle == null || obj.couponsAmountPerBundle === 0) {
        obj.couponsAmountPerBundle = null;
      }
      // couponsBonusesAmount debe ser el valor que ingresó el usuario (puede ser 0)
      if (obj.couponsBonusesAmount === "" || obj.couponsBonusesAmount == null) {
        obj.couponsBonusesAmount = null;
      }
    }
    
    console.log("🔍 Payload enviado al backend:", obj);
    console.log("🔍 expirationDate en el payload:", obj.expirationDate);
    console.log("🔍 couponsAmountPerBundle en el payload:", obj.couponsAmountPerBundle);
    setLoading(true);
    editRaffle
      ? raffleService
        .editRaffle(
          form.game.modality.game.id,
          form.game.modality.mode.id,
          obj,
        )
        .then((res) => {
          if (res.id) {
            Swal.fire({
              icon: "success",
              title: editRaffle
                ? t("raffleEditedSuccesfully")
                : t("raffleCreatedSuccesfully"),
              showConfirmButton: false,
              timer: 1200,
            });
            callAllRaffles();
            navigate(-1);
          }
        })
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoading(false);
          callAllRaffles();
          navigate(-1);
        })
      : raffleService
        .createRaffle(
          form.game.modality.game.id,
          form.game.modality.mode.id,
          obj,
        )
        .then((res) => {
          if (res.id) {
            Swal.fire({
              icon: "success",
              title: editRaffle
                ? t("raffleEditedSuccesfully")
                : t("raffleCreatedSuccesfully"),
              showConfirmButton: false,
              timer: 1200,
            });
            if (modal) {
              setRaffleSelected(res);
              setDetail((prev) => ({ ...prev, raffleId: res.id }));
              setCreate(false);
              setOpen(false);
            }
            setLoading(false);
            callAllRaffles();
            navigate(-1);
          } else {
            Swal.fire({
              icon: "error",
              title: t("sorryErrorOcurred"),
              showConfirmButton: false,
              timer: 1200,
            });
          }
        })
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoading(false);
          callAllRaffles();
          navigate(-1);
        });
  };

  const handleActivate = () => {
    let today = new Date();
    let todayIso = new Date(today.toISOString().split("T")[0]);
    let expirationDate =
      form?.expirationDate === null
        ? null
        : new Date(form?.expirationDate.split("T")[0]);
    if (expirationDate !== null && todayIso <= expirationDate) {
      setOpenError(true);
    } else {
      setForm((prev) => ({ ...prev, status: !form.status }));
    }
  };

  useEffect(() => {
    setGameOffers(gameOffersRedux.content);
  }, [allGameOffersActive, gameOffersRedux]);

  useEffect(() => {
    if (gameOffersActive.length === 0) {
      gamesService
        .getAllActivesGameOffers(dispatch)
        .then((response) => setGameOffersActive(response.content));
    }
  }, [organizationId, dispatch, gameOffersActive]);

  useEffect(() => {
    if (!gameOffersRedux) {
      gamesService.getAllGameOffers();
    }
  }, [gameOffersRedux, dispatch, organizationId]);

  useEffect(() => {
    const gameWithModality = gameOffers.find(
      (g) => g?.modality?.game?.id === editRaffle?.game?.id,
    );
    setForm({ ...form, game: gameWithModality });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameOffers, editRaffle]);

  //Errores para evitar envio
  useEffect(() => {
    const condition =
      form?.game?.modality?.mode?.name?.toLowerCase() === "instantaneo"
        ? errors.serie ||
        form.serie === "" ||
        errors.price ||
        form.price === "" ||
        errors.percentage ||
        form.percentage === "" ||
        errors.couponsAmountPerBundle ||
        form.couponsAmountPerBundle === "" ||
        errors.couponsBonusesAmount ||
        form.couponsBonusesAmount === ""
        :
        form?.game?.modality?.mode?.name?.toLowerCase() === "preimpreso"
          ? errors.number ||
          form.number === "" ||
          errors.price ||
          form.price === "" ||
          !form.raffleDate ||
          !form.openDate ||
          !form.offlineDeadline ||
          !form.onlineDeadline ||
          !form.expirationDate ||
          !form.eventDate ||
          !form.settlementDate
          :
          errors.number ||
          form.number === "" ||
          errors.price ||
          form.price === "" ||
          !form.raffleDate ||
          !form.openDate ||
          !form.offlineDeadline ||
          !form.onlineDeadline ||
          !form.expirationDate ||
          !form.eventDate
      ;
    if (condition) {
      setDisabled(true);
    } else if (!form.game || !form.lottery) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [form, errors]);

  return (
    <Grid container className={s.container}>
      {modal ? (
        <Grid item xs={11}>
          <ArrowBackIosNewIcon
            sx={{ color: "primary.main" }}
            onClick={() => setCreate(false)}
            className={s.arrow}
          />
        </Grid>
      ) : (
        <Grid item xs={10} className={s.titleContainer}>
          <ArrowBackIcon
            sx={{ color: "primary.main", fontSize: "2rem" }}
            onClick={() => {
              navigate("../productos");
              setEditRaffle(null);
            }}
            className={s.arrow}
          />
          <h4>{editRaffle ? t("editionForm") : t("creationForm")}</h4>
        </Grid>
      )}
      <Grid container item xs={12} className={s.form}>
        <Grid item lg={modal ? 12 : 5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("game") + "*"}</p>
          {editRaffle ? (
            <TextField
              id="outlined-basic"
              variant="outlined"
              disabled
              value={form?.game?.name}
              sx={{ width: "80%" }}
            />
          ) : (
            <FormControl sx={{ width: "80%" }}>
              <Select
                value={form.game}
                onChange={(e) => {
                  if (
                    e.target.value.modality?.mode?.name?.toLowerCase() ===
                    "preimpreso"
                  ) {
                    setForm({ ...form, game: e.target.value, serie: "" });
                  } else {
                    setForm({ ...form, game: e.target.value, number: "" });
                  }
                }}
              >
                {gameOffersActive?.map((g, i) => (
                  <MenuItem key={i} value={g}>
                    {g.modality.game.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Grid>
        {form?.game?.modality?.mode?.name?.toLowerCase() === "instantaneo" ? (
          <>
            <Grid
              item
              lg={modal ? 12 : 5}
              md={10}
              xs={12}
              className={s.inputItem}
            >
              <p className={s.titleinput}>{t("serie") + "*"}</p>
              <TextField
                sx={{ width: "80%" }}
                placeholder={t("placeHolderNumber")}
                variant="outlined"
                error={errors.serie}
                value={form.serie}
                onChange={(e) => {
                  setForm({ ...form, serie: e.target.value });
                }}
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid
              item
              lg={modal ? 12 : 5}
              md={10}
              xs={12}
              className={s.inputItem}
            >
              <p className={s.titleinput}>{t("drawNumber") + "*"}</p>
              <TextField
                sx={{ width: "80%" }}
                placeholder={t("placeHolderDrawNumber")}
                error={errors.number}
                helperText={
                  errors.number
                    ? "⚠ El número debe ser válido y menor a 2147483647."
                    : ""
                }
                variant="outlined"
                value={form.number}
                onChange={(e) => {
                  !isNaN(e.target.value) && e.target.value * 1 <= 2147483647
                    ? setErrors({ ...errors, number: false })
                    : setErrors({ ...errors, number: true });
                  setForm({
                    ...form,
                    number: !isNaN(e.target.value)
                      ? e.target.value * 1
                      : e.target.value,
                  });
                }}
                onKeyPress={(e) => {
                  if (e?.key === "-" || e?.key === "+") {
                    e.preventDefault();
                  }
                }}
              />
            </Grid>
          </>
        )}
        {/*<Grid item lg={modal ? 12 : 5} md={10} xs={12} className={s.inputItem}>
          {/* TODO: Cambiar segun el mode del Juego seleccionado.
          {/* {form?.game?.modality?.mode?.name?.toLowerCase() ===  "instantaneo" ? <>
                          <p className={s.titleinput}>{t('provider')}</p>
                          <TextField sx={{width: '80%'}} variant="outlined" placeholder={"Setear según juego"} disabled/>
                        </> :
          <>
            <p className={s.titleinput}>{t("lottery") + "*"}</p>
            {editRaffle ? (
              <TextField
                id="outlined-basic"
                variant="outlined"
                disabled
                value={form?.lottery?.name}
                sx={{ width: "80%" }}
              />
            ) : (
              <FormControl sx={{ width: "80%" }}>
                <Select
                  value={form.lottery}
                  onChange={(e) =>
                    setForm({ ...form, lottery: e.target.value })
                  }
                >
                  {raffleLotteries?.map((l, i) => (
                    <MenuItem key={i} value={l}>
                      {l.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </>
        </Grid>
        {/* } */}
        <Grid item lg={modal ? 12 : 5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("price") + "*"}</p>
          <TextField
            sx={{ width: "80%" }}
            variant="outlined"
            error={errors.price}
            helperText={
              errors.price
                ? "⚠ El precio debe ser válido y de una logitud menor a 7 (siete)."
                : ""
            }
            value={form.price}
            placeholder={t("placeHolderPrice")}
            onChange={(e) => {
              !isNaN(e.target.value) && e.target.value.length <= 7
                ? setErrors({ ...errors, price: false })
                : setErrors({ ...errors, price: true });
              setForm({
                ...form,
                price: !isNaN(e.target.value)
                  ? e.target.value * 1
                  : e.target.value,
              });
            }}
            onKeyPress={(e) => {
              if (e?.key === "-" || e?.key === "+") {
                e.preventDefault();
              }
            }}
          />
        </Grid>
        <Grid
          container
          item
          lg={modal ? 12 : 5}
          md={10}
          xs={12}
          className={s.inputItem}
        >
          <p className={s.titleinput}>{t("state") + "*"}</p>
          <Grid
            className={s.active}
            item
            sx={{ display: "flex", alignItems: "center" }}
          >
            <p style={{ fontSize: "1rem" }}>
              {form.status ? t("active") : t("inactive")}
            </p>
            <Switch checked={form.status} onChange={() => handleActivate()} />
          </Grid>
        </Grid>
        {form?.game?.modality?.mode?.name?.toLowerCase() === "instantaneo" ? (
          <Grid
            item
            lg={modal ? 12 : 5}
            md={10}
            xs={12}
            className={s.inputItem}
          >
            <p className={s.titleinput}>{t("percentageMinorPrizes") + "*"}</p>
            <TextField
              sx={{ width: "80%" }}
              variant="outlined"
              error={errors.percentage}
              helperText={
                errors.percentage
                  ? "⚠ El porcentaje debe ser válido y comprendido entre 0-100 con máximo de dos números decimales separados por un . (punto)."
                  : ""
              }
              value={form.percentage}
              placeholder={t("placeHolderPercentaje")}
              type="number"
              inputProps={{ min: 0 }}
              onChange={(e) => {
                percentajeTest.test(e.target.value)
                  ? setErrors({ ...errors, percentage: false })
                  : setErrors({ ...errors, percentage: true });
                setForm({ ...form, percentage: e.target.value });
              }}
              onKeyDown={(e) => {
                if (
                  e?.key === "-" ||
                  e?.key === "+" ||
                  e?.key === "e" ||
                  e?.key === "E"
                ) {
                  e.preventDefault();
                }
              }}
            />
          </Grid>
        ) : (
          <></>
        )}
        <Grid item lg={modal ? 12 : 5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("withholdingAmount")}</p>
          <TextField
            sx={{ width: "80%" }}
            placeholder={t("withholdingAmount")}
            variant="outlined"
            type="number"
            value={form.withHoldingAmount}
            onChange={(e) => {
              if (!isNaN(e.target.value) && Number(e.target.value) >= 0) {
                setForm({
                  ...form,
                  withHoldingAmount: Number(e.target.value) || null,
                });
              }
            }}
            onKeyDown={(e) => {
              if (
                e?.key === "-" ||
                e?.key === "+" ||
                e?.key === "e" ||
                e?.key === "E"
              ) {
                e.preventDefault();
              }
            }}
            inputProps={{ min: 0 }}
          />
        </Grid>
        <Grid item lg={modal ? 12 : 5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("withholding")}</p>
          <TextField
            sx={{ width: "80%" }}
            placeholder={t("percentage")}
            variant="outlined"
            type="number"
            value={form.retentionWithHolding}
            onChange={(e) => {
              if (
                !isNaN(e.target.value) &&
                e.target.value <= 100 &&
                e.target.value >= 0
              ) {
                setForm({
                  ...form,
                  retentionWithHolding: Number(e.target.value) || null,
                });
              }
            }}
            onKeyDown={(e) => {
              if (
                e?.key === "-" ||
                e?.key === "+" ||
                e?.key === "e" ||
                e?.key === "E"
              ) {
                e.preventDefault();
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">%</InputAdornment>
              ),
            }}
            inputProps={{ min: 0 }}
          />
        </Grid>
        <Grid item lg={modal ? 12 : 5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("stimulus")}</p>
          <TextField
            sx={{ width: "80%" }}
            variant="outlined"
            placeholder={t("percentage")}
            type="number"
            value={form.retentionStimulus}
            inputProps={{ min: 0 }}
            onChange={(e) => {
              if (!isNaN(e.target.value) && Number(e.target.value) >= 0) {
                setForm({
                  ...form,
                  retentionStimulus: Number(e.target.value) || null,
                });
              }
            }}
            onKeyDown={(e) => {
              if (
                e?.key === "-" ||
                e?.key === "+" ||
                e?.key === "e" ||
                e?.key === "E"
              ) {
                e.preventDefault();
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">%</InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item lg={modal ? 12 : 5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("taxable")}</p>
          <TextField
            sx={{ width: "80%" }}
            variant="outlined"
            placeholder={t("percentage")}
            type="number"
            value={form.taxable}
            inputProps={{ min: 0 }}
            onChange={(e) => {
              if (
                !isNaN(e.target.value) &&
                e.target.value <= 100 &&
                e.target.value >= 0
              ) {
                setForm({ ...form, taxable: Number(e.target.value) || null });
              }
            }}
            onKeyDown={(e) => {
              if (
                e?.key === "-" ||
                e?.key === "+" ||
                e?.key === "e" ||
                e?.key === "E"
              ) {
                e.preventDefault();
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">%</InputAdornment>
              ),
            }}
          />
        </Grid>
        {/* <Grid item lg={modal ? 12 : 5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("incentive")}</p>
          <TextField
            sx={{ width: "80%" }}
            variant="outlined"
            placeholder={t("quantity")}
            type="number"
            value={form.incentive}
            onChange={(e) => {
              if (!isNaN(e.target.value) && Number(e.target.value) >= 0) {
                setForm({ ...form, incentive: Number(e.target.value) || null });
              }
            }}
            onKeyDown={(e) => {
              if (
                e?.key === "-" ||
                e?.key === "+" ||
                e?.key === "e" ||
                e?.key === "E"
              ) {
                e.preventDefault();
              }
            }}
          />
        </Grid> */}
        {form?.game?.modality?.mode?.name?.toLowerCase() === "instantaneo" ? (
          <>
            <Grid item lg={modal ? 12 : 5} md={10} xs={12} className={s.inputItem}>
              <p className={s.titleinput}>{t("couponPerPackage") + "*"}</p>
              <TextField
                sx={{ width: "80%" }}
                variant="outlined"
                placeholder={t("quantity")}
                error={errors.couponsAmountPerBundle}
                helperText={
                  errors.couponsAmountPerBundle
                    ? "⚠ El número debe ser válido"
                    : ""
                }
                type="number"
                value={form.couponsAmountPerBundle}
                onChange={(e) => {
                  !isNaN(e.target.value)
                    ? setErrors({ ...errors, couponsAmountPerBundle: false })
                    : setErrors({ ...errors, couponsAmountPerBundle: true });
                  setForm((prev) => {
                    return {
                      ...prev,
                      couponsAmountPerBundle: Number(e.target.value),
                    }
                  });
                }}
                onKeyDown={(e) => {
                  if (
                    e?.key === "-" ||
                    e?.key === "+" ||
                    e?.key === "e" ||
                    e?.key === "E"
                  ) {
                    e.preventDefault();
                  }
                }}
              />
            </Grid>
            <Grid item lg={modal ? 12 : 5} md={10} xs={12} className={s.inputItem}>
              <p className={s.titleinput}>{t("bonusCoupons") + "*"}</p>
              <TextField
                sx={{ width: "80%" }}
                variant="outlined"
                placeholder={t("quantity")}
                error={errors.couponsBonusesAmount}
                helperText={
                  errors.couponsBonusesAmount
                    ? "⚠ El número debe ser válido"
                    : ""
                }
                type="number"
                value={form.couponsBonusesAmount}
                inputProps={{ min: 0 }}
                onChange={(e) => {
                  !isNaN(e.target.value)
                    ? setErrors({ ...errors, couponsBonusesAmount: false })
                    : setErrors({ ...errors, couponsBonusesAmount: true });
                  setForm((prev) => {
                    return {
                      ...prev,
                      couponsBonusesAmount: Number(e.target.value),
                    }
                  });
                }}
                onKeyDown={(e) => {
                  if (
                    e?.key === "-" ||
                    e?.key === "+" ||
                    e?.key === "e" ||
                    e?.key === "E"
                  ) {
                    e.preventDefault();
                  }
                }}
              />
            </Grid></>
        ) : (
          <></>
        )}
        <Grid
          item
          lg={modal ? 0 : 5}
          md={10}
          xs={12}
          className={s.inputItem}
        ></Grid>
        {form?.game?.modality?.mode?.name?.toLowerCase() === "instantaneo" ? (
          <></>
        ) : (
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={locale}
          >
            <Grid
              item
              lg={9}
              md={8}
              xs={9.5}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <h4 style={{ fontSize: "1rem", fontWeight: "600" }}>
                {t("dates")}
              </h4>
            </Grid>
            <Grid
              item
              container
              lg={modal ? 11 : 4.5}
              md={10.5}
              xs={12}
              sx={{ justifyContent: "center", mt: 2 }}
            >
              <Grid item lg={6} md={5} xs={12} className={s.inputItem}>
                <h3 style={{ width: "80%" }}>{t("drawDate") + "*"}</h3>
                <DesktopDatePicker
                  label={"dd/mm/aaaa"}
                  autoOk
                  fullWidth
                  minDate={today()}
                  value={form.raffleDate}
                  inputProps={{
                    readOnly: true,
                  }}
                  onChange={(e) => {
                    const dateToSet = dateTransformer(e.$d);
                    setForm({ ...form, raffleDate: dateToSet });
                  }}
                  inputFormat="DD/MM/YYYY"
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "80%" }} />
                  )}
                />
              </Grid>
              <Grid
                item
                lg={6}
                md={5}
                xs={12}
                className={s.inputItem}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <h3 style={{ width: "80%" }}>{t("opening") + "*"}</h3>
                <DesktopDatePicker
                  label={"dd/mm/aaaa"}
                  autoOk
                  fullWidth
                  inputProps={{
                    readOnly: true,
                  }}
                  minDate={editRaffle ? false : today()}
                  value={form.openDate}
                  onChange={(e) => {
                    const dateToSet = dateTransformer(e.$d);
                    setForm({ ...form, openDate: dateToSet });
                  }}
                  inputFormat="DD/MM/YYYY"
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "80%" }} />
                  )}
                />
              </Grid>
            </Grid>

            <Grid item lg={modal ? 0 : 0.5}></Grid>
            <Grid
              item
              container
              lg={modal ? 11 : 4.5}
              md={10.5}
              xs={12}
              sx={{ justifyContent: "center", mt: 2 }}
            >
              <Grid
                item
                lg={6}
                md={5}
                xs={12}
                className={s.inputItem}
                sx={{ flexDirection: "row", textAlign: "start" }}
              >
                <h3 style={{ width: "80%" }}>{t("offlineDeadline") + "*"}</h3>
                <DesktopDatePicker
                  label={"dd/mm/aaaa"}
                  autoOk
                  fullWidth
                  minDate={editRaffle ? false : today()}
                  inputProps={{
                    readOnly: true,
                  }}
                  value={form.offlineDeadline}
                  onChange={(e) => {
                    const dateToSet = dateTransformer(e.$d);
                    // onlineDeadline debe tener el mismo valor que offlineDeadline (fecha límite de venta)
                    setForm({ ...form, offlineDeadline: dateToSet, onlineDeadline: dateToSet });
                  }}
                  inputFormat="DD/MM/YYYY"
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "80%" }} />
                  )}
                />
              </Grid>
              <Grid
                item
                lg={6}
                md={5}
                xs={12}
                className={s.inputItem}
                sx={{ flexDirection: "row", textAlign: "start" }}
              >
                <h3 style={{ width: "80%" }}>{t("dateOfExpiry") + "*"}</h3>
                <DesktopDatePicker
                  label={"dd/mm/aaaa"}
                  autoOk
                  fullWidth
                  inputProps={{
                    readOnly: true,
                  }}
                  minDate={today()}
                  value={form.expirationDate}
                  onChange={(e) => {
                    console.log("Expiry date :", e);
                    const dateToSet = dateTransformer(e.$d);
                    setForm({ ...form, expirationDate: dateToSet });
                  }}
                  inputFormat="DD/MM/YYYY"
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "80%" }} />
                  )}
                />
              </Grid>
            </Grid>
            <Grid
              item
              container
              lg={modal ? 11 : 4.5}
              md={10.5}
              xs={12}
              sx={{ justifyContent: "center", mt: 2 }}
            >
              {form?.game?.modality?.mode?.name?.toLowerCase() === "preimpreso" ? (
                <Grid
                  item
                  lg={6}
                  md={5}
                  xs={12}
                  className={s.inputItem}
                  sx={{ flexDirection: "row", textAlign: "start" }}
                >
                  <h3 style={{ width: "80%" }}>{t("settlementDate") + "*"}</h3>
                  <DesktopDatePicker
                    label={"dd/mm/aaaa"}
                    autoOk
                    fullWidth
                    inputProps={{
                      readOnly: true,
                    }}
                    minDate={form?.raffleDate ? today(form?.raffleDate) : today()}
                    value={form.settlementDate}
                    onChange={(e) => {
                      const dateToSet = dateTransformer(e.$d);
                      setForm((prev) => ({ ...prev, settlementDate: dateToSet }));
                    }}
                    inputFormat="DD/MM/YYYY"
                    renderInput={(params) => (
                      <TextField {...params} sx={{ width: "80%" }} />
                    )}
                  />
                </Grid>
              ) :
                (
                  <></>
                )}
            </Grid>
          </LocalizationProvider>
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 2,
          mb: 4,
        }}
      >
        <Button
          variant="contained"
          sx={{ width: "30%" }}
          disabled={disabled || loading}
          onClick={handleCreate}
        >
          {loading ? <CircularProgress /> : editRaffle ? t("edit") : t("add")}
        </Button>
      </Grid>

      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="warning"
          sx={{ width: "100%" }}
        >
          {t("vigencyErrorDate")}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default CreateRaffle;
